var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45.07 45.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #6f1d46;\n        stroke-miterlimit: 10;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.47,9.28c10.21,7.28,23.92,7.28,34.13,0m4.97,13.26H.5M22.54,.5V44.57m-.11-44.07C10.25,.56,.44,10.48,.5,22.65c.06,12.17,9.98,21.98,22.15,21.92,12.17-.06,21.98-9.98,21.92-22.15-.06-12.08-9.84-21.86-21.92-21.92h-.23Zm-1.34-.02c-13.37,13.18-13.37,30.88,0,44.06m-15.61-8.08c10.21-7.28,23.92-7.28,34.13,0M24.37,.69c13.28,13.09,13.28,30.67,0,43.76"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/WEB.4c101aa2bd5e5b2bac0460f9842043f2.svg";
export { ForwardRef as ReactComponent };